// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  version: '1.55.1',
  production: false,
  environment: 'dev',
  prePath: '',
  BASE_API_URL: 'https://dev-orderadmin-service.jamatu.com',
  i18nBaseUrl: 'https://dev-orderadmin-service.jamatu.com/api/i18n',
  API_URL: 'https://dev-orderapp-api.jamatu.com/api/v1',
  OA_API_URL: 'https://dev-orderadmin-api.jamatu.com/api/v1',
  OAS_API_URL: 'https://dev-orderadmin-service.jamatu.com/api',
  GOOLGLE_TAG_KEY: 'G-DVLQXM41RQ',
  enableCashForPickupTesting: true,
  enableCashForTakeAwayTesting: true,
  enableCashForSplitBillTesting: true,
  // JO-3115: guest accounts. Auth0 application "JamOrder" in the dev tenant.
  AUTH0_DOMAIN: 'dev-mexdubsh7cvlq1b8.us.auth0.com',
  AUTH0_CLIENTID: 'iTonzae8zZzSblfzfRD5Lu0fs8rkEj10',
  AUTH0_AUDIENCE: 'https://dev-orderadmin-api.jamatu.com/',
  // JO-3146: the cluster load balances across replicas, which breaks the two-request
  // SignalR handshake. See core/utils/signalr-transport.util.ts.
  SIGNALR_SKIP_NEGOTIATION: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
